import { z } from 'zod';
export const healthResponseSchema = z.object({
    status: z.literal('ok'),
    /** ISO 8601, UTC. All timestamps are stored and transported in UTC. */
    time: z.iso.datetime(),
    /**
     * Which build is answering — the image's own tag (`1.0.1` from a release,
     * `main` from a branch build), `dev` when the server runs from source.
     *
     * It is here, on the one route reachable without a session, because "which
     * version is actually running" has to be answerable **after** a deployment
     * and from outside: if the deployment went half wrong, signing in may be
     * precisely what does not work, and a checkpoint that fails exactly when it
     * is needed is not a checkpoint.
     *
     * The commit deliberately does not travel with it. It names a point in a
     * private repository, it tells an operator nothing the version does not, and
     * the place it belongs is the startup log line — where it is read by whoever
     * already has the logs.
     */
    version: z.string().min(1),
});
//# sourceMappingURL=health.js.map